import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bd0c278e")

_pushScopeId("data-v-bd0c278e")
const _hoisted_1 = { class: "accounting-mobile-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "accounting-actions-cancel",
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
    }, _toDisplayString(_ctx.$t('button.back')), 1),
    (_ctx.editMode)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "accounting-actions-save",
          form: _ctx.form,
          type: "submit"
        }, _toDisplayString(_ctx.$t('button.save')), 9, ["form"]))
      : (_openBlock(), _createBlock("button", {
          key: 1,
          class: "accounting-actions-edit",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit()))
        }, _toDisplayString(_ctx.$t('button.edit')), 1))
  ]))
})